import { render, staticRenderFns } from "./HomeCardsGallery.vue?vue&type=template&id=64977d7c&scoped=true"
import script from "./HomeCardsGallery.vue?vue&type=script&lang=js"
export * from "./HomeCardsGallery.vue?vue&type=script&lang=js"
import style0 from "./HomeCardsGallery.vue?vue&type=style&index=0&id=64977d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64977d7c",
  null
  
)

export default component.exports